/**
 * A move that can't be taken back once it's made (a retreat, Switch) waits a few seconds with an Undo before it's
 * sent: nothing reaches the server until then, so there's nothing to take back.
 */
export const UNDO_WINDOW_MS = 4000;
export const UNDO_WAITING = 'UNDO/WAITING';
export const UNDO_MOVE = 'UNDO/UNDO_MOVE';
/** Sure of it: the move goes now, without waiting out its Undo. */
export const SEND_NOW = 'UNDO/SEND_NOW';
export const UNDO_DONE = 'UNDO/DONE';
/** Not undone: the move is on its way; its swap stays shown until the game answers. */
export const UNDO_SENDING = 'UNDO/SENDING';
